import React from "react";
import { Link } from "react-router-dom";
import blogDetailImage from "../images/blog/blog-detail.jpg";
import authorImage from "../images/blog/author-01.png";

const BlogDetails = () => {
  return (
    <section className="pt-[150px] pb-[110px] lg:pt-[220px]">
      <div className="container max-w-[1100px]">
        <article className="wow fadeInUp" data-wow-delay=".2s">
          <div className="mb-10">
            <img
              src={blogDetailImage}
              alt="Blog detail"
              className="w-full rounded-lg"
            />
          </div>

          <div className="flex items-center mb-6 text-sm text-body">
            <span>Dr. García</span>
            <span className="mx-2">•</span>
            <span>Enero 15, 2025</span>
            <span className="mx-2">•</span>
            <span>5 min de lectura</span>
          </div>

          <h1 className="mb-6 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[45px]">
            Cuidados Neurológicos para Mascotas
          </h1>

          <div className="prose dark:prose-invert max-w-none">
            <p className="mb-6 text-base leading-relaxed text-body">
              La salud neurológica de nuestras mascotas es fundamental para su
              bienestar general. En este artículo, exploraremos los aspectos más
              importantes del cuidado neurológico veterinario y cómo podemos
              identificar posibles problemas en nuestros compañeros peludos.
            </p>

            <h2 className="mt-8 mb-4 text-2xl font-bold text-black dark:text-white">
              Signos de Problemas Neurológicos
            </h2>
            <p className="mb-6 text-base leading-relaxed text-body">
              Es importante estar atentos a cualquier cambio en el
              comportamiento de nuestra mascota. Algunos signos que pueden
              indicar problemas neurológicos incluyen:
            </p>

            <ul className="mb-6 ml-6 space-y-2 text-base list-disc text-body">
              <li>Pérdida de equilibrio o coordinación</li>
              <li>Cambios en el comportamiento habitual</li>
              <li>Movimientos involuntarios o convulsiones</li>
              <li>Debilidad en las extremidades</li>
              <li>Cambios en la visión o pupilas de tamaño diferente</li>
            </ul>

            <h2 className="mt-8 mb-4 text-2xl font-bold text-black dark:text-white">
              Prevención y Cuidados
            </h2>
            <p className="mb-6 text-base leading-relaxed text-body">
              La prevención es clave en la salud neurológica. Mantener un peso
              saludable, proporcionar ejercicio regular y una dieta balanceada
              son fundamentales. Además, las revisiones veterinarias periódicas
              pueden ayudar a detectar problemas en etapas tempranas.
            </p>

            <p className="mb-6 text-base leading-relaxed text-body">
              Si observas cualquiera de estos síntomas en tu mascota, no dudes
              en contactarnos. Nuestro equipo especializado en neurología
              veterinaria está preparado para brindarte el mejor cuidado
              posible.
            </p>
          </div>

          <div className="flex items-center p-6 mt-10 rounded-lg bg-[#F8FAFB] dark:bg-[#15182A]">
            <img
              src={authorImage}
              alt="Dr. García"
              className="w-16 h-16 rounded-full"
            />
            <div className="ml-4">
              <h4 className="mb-1 text-lg font-semibold text-black dark:text-white">
                Dr. García
              </h4>
              <p className="text-sm text-body">
                Especialista en Neurología Veterinaria
              </p>
            </div>
          </div>

          <div className="mt-10">
            <Link
              to="/blog-grid"
              className="inline-flex items-center text-base font-medium text-primary hover:underline"
            >
              <svg
                className="mr-2"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 14.25L2.25 9L7.5 3.75"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.25 9H15.75"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Volver al blog
            </Link>
          </div>
        </article>
      </div>
    </section>
  );
};

export default BlogDetails;
